import React from "react";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { Box } from "../../../Box";
import { DisconnectionPropertyDetails } from "../../../../types/DisconnectionPropertyDetails";
import { AddressIcpLookupField } from "../../../AddressIcpLookupField";
import { DisconnectionPropertyDetailsMeterForm } from "../DisconnectionPropertyDetailsMeterForm";
import { DisconnectionPropertyDetailsType } from "../DisconnectionPropertyDetailsType";
import { DisconnectionPropertyDetailsIssues } from "../DisconnectionPropertyDetailsIssues";

interface Props {
  id: string;
  propertyDetails: DisconnectionPropertyDetails;
  validateField: (field: string) => void;
}

export const DisconnectionPropertyDetailsForm: React.FC<Props> = ({
  id,
  propertyDetails,
  validateField,
}) => {
  return (
    <Box id={id}>
      <Flex mt={5}>
        <Span
          display="inline-block"
          fontSize={4}
          lineHeight={4}
          fontWeight="medium"
        >
          Property details
        </Span>
      </Flex>

      <Flex mt={5} mb={1} flexDirection="column">
        <AddressIcpLookupField
          id={`${id}-icp-lookup`}
          icpNumber={propertyDetails.icpAddressLookup.id}
          validateField={validateField}
        />

        <DisconnectionPropertyDetailsMeterForm
          id={`${id}-meters`}
          propertyDetails={propertyDetails}
          validateField={validateField}
          addressCaptureEnabled={!propertyDetails.icpAddressLookupEnabled}
        />

        <DisconnectionPropertyDetailsType id={`${id}-type`} />

        <DisconnectionPropertyDetailsIssues id={`${id}-issues`} />
      </Flex>
    </Box>
  );
};
